import {
	Renderer2,
	Component,
	HostListener,
	OnInit,
	ElementRef,
	Injector,
	ViewChild,
	HostBinding,
	ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseComponent } from '../../base.component';
import * as bowser from 'bowser';
import { DomSanitizer } from '@angular/platform-browser';
import { LinkExpirationServie } from 'src/app/Services/link-expiration/link-expiration';
import { filter, isEmpty } from 'lodash';
import { SubmissionPreloaderPopupComponent } from '../../general/submission-preloader-popup/submission-preloader-popup.component';
import { InformationModalService } from 'src/app/Services/information-model-factory/information-model-factory';

@Component({
	selector: 'sidebar',
	template: `
		<submission-preloader-popup
			id="submission-preloader-popup"
			*ngIf="showSubmissionLoader_Popup"
			[modal]="submissionLoaderPopupData"
		></submission-preloader-popup>
		<div class="sidebar" *ngIf="model && model.metadata.progressMeter && model.metadata.progressMeter.visible">
			<progress-meter [progressMeter]="model.metadata.progressMeter"> </progress-meter>
		</div>
		<div *ngIf="isCovModFlagOn && isCustomizable" class="online-buy-gutter">
			<hr />
			<ng-container>
				<div>
					<div
						*ngIf="
							(selectedPackageType != 'Custom' || (selectedPackageType == 'Custom' && !isEditMode())) &&
							!isAgentflowType
						"
						class="buy-this-policy-label"
						[ngClass]="{ 'new-design': shouldShowCovMod }"
					>
						{{ shouldShowCovMod ? 'All your info is saved!' : 'Buy this policy!' }}
					</div>
					<div
						*ngIf="selectedPackageType != 'Custom' || (selectedPackageType == 'Custom' && !isEditMode())"
						class="price"
					>
						<span class="sup">$</span>
						{{ selectedPackagePrice }}
					</div>
					<button
						*ngIf="selectedPackageType == 'Custom' && isEditMode()"
						class="finish-and-buy-button"
						[disabled]="updateRateButton && updateRateButton.disabled"
						[ngClass]="{
							disabled: updateRateButton && updateRateButton.disabled
						}"
						(click)="UpdateRateBtnClick()"
					>
						<div *ngIf="isRecalculating()" class="loader-spinner"></div>
						<div *ngIf="!isRecalculating()">
							{{ 'Update rate' }}
						</div>
					</button>
					<button
						*ngIf="
							!shouldShowCovMod &&
							(selectedPackageType != 'Custom' || (selectedPackageType == 'Custom' && !isEditMode()))
						"
						class="finish-and-buy-button"
						(click)="finishAndBuyBtnClick()"
						[disabled]="buyButton && buyButton.disabled"
						[ngClass]="{
							disabled: buyButton && buyButton.disabled
						}"
					>
						{{ 'Finish and Buy' }}
					</button>
					<button
						*ngIf="
							shouldShowCovMod &&
							(selectedPackageType != 'Custom' || (selectedPackageType == 'Custom' && !isEditMode()))
						"
						class="finish-and-buy-button"
						(click)="phoneClick()"
					>
						<a
							tabindex="0"
							class="phone"
							[href]="'tel:' + model.metadata.progressMeter.phoneNumber"
							(keydown.enter)="phoneClick()"
						>
							<span tabindex="-1" (click)="phoneClick()">
								{{ model.metadata.progressMeter.phoneNumber }}
							</span>
						</a>
					</button>
					<p
						class="online-phone"
						*ngIf="!isAgentflowType && (!shouldShowCovMod || (selectedPackageType == 'Custom' && isEditMode()))"
					>
						or Call an expert at <br />
						<a
							tabindex="0"
							class="phone"
							[href]="'tel:' + model.metadata.progressMeter.phoneNumber"
							(keydown.enter)="phoneClick()"
						>
							<span tabindex="-1" (click)="phoneClick()">
								{{ model.metadata.progressMeter.phoneNumber }}
							</span>
						</a>
					</p>
					<p>Quote Number:</p>
					<p>{{ quoteNumber }}</p>
				</div>
			</ng-container>
		</div>
	`,
	styleUrls: ['./sidebar.component.scss'],
})
export class SideBarComponent extends BaseComponent implements OnInit {
	model: data;
	elementRef: ElementRef;
	isFixed: boolean;
	subscription: Subscription;
	contentElem: any;
	headerElem: any;
	isSubmissionLoaderFlagOn: boolean = false;
	isCovModFlagOn: boolean = false;
	isCustomizable: boolean = false;
	selectedPackagePrice: number;
	selectedPackageType: any = 'Popular';
	quoteNumber: any;
	buyButton: any;
	updateRateButton: any;
	isAgentflowType: boolean;
	shouldShowNewSubmissionLoader: boolean = false;
	submissionLoaderPopup: any;
	showSubmissionLoader_Popup = false;
	submissionLoaderPopupData: any;
	@ViewChild('content', { static: true, read: ViewContainerRef })
	container: ElementRef;
	shouldShowCovMod: boolean = false;

	@HostBinding('class.showForMobile')
	showForMobile: boolean;

	@HostListener('window:scroll', [])
	onScroll() {
		this.calcFixed();
	}

	constructor(
		injector: Injector,
		private renderer: Renderer2,
		private sanitizer: DomSanitizer,
		private linkExpiration: LinkExpirationServie,
		private informationModalService: InformationModalService
	) {
		super(injector);
		this.elementRef = injector.get(ElementRef);
	}

	async ngOnInit() {
		this.layoutService.staticLayout.subscribe((data) => {
			if (data) {
				this.model = data.data;
				if (this.model.metadata && this.model.metadata.progressMeter) {
					this.showForMobile = true;
				}
				this.calcFixed = this.calcFixed.bind(this);
				this.contentElem = document.getElementById('interviewContent');
				this.headerElem = document.getElementsByTagName('header')[0];
				this.isCovModFlagOn = this.model.globalAttributes['covModFlag'];
				this.isSubmissionLoaderFlagOn = this.model.globalAttributes['submissionLoaderFlag'];
				this.isAgentflowType = this.model.globalAttributes['flowType'] == 'Agent';
				if (this.isCovModFlagOn) {
					this.carrierInformationService.setIsRecalculating(false);
					var carrierInformation = this.storeService.getValue('CarrierInformation', 'page');
					this.isCustomizable = carrierInformation.isCustomizable;

					if (
						(carrierInformation.onlinebuy != null && carrierInformation.onlinebuy == false) ||
						(data.data.metadata.page.controls.find((c) => c.controlName == 'Comparison') &&
							data.data.metadata.page.controls
								.find((c) => c.controlName == 'Comparison')
								.attributes.options.find((o) => o.name == carrierInformation.name))
					) {
						this.shouldShowCovMod =
							(carrierInformation.onlinebuy != null && carrierInformation.onlinebuy == false) ||
							!data.data.metadata.page.controls
								.find((c) => c.controlName == 'Comparison')
								.attributes.options.find((o) => o.name == carrierInformation.name).value.onlinebuy;
					}

					if (
						data.data.metadata.page.controls.find((c) => c.controlName == 'CoveragePackages') &&
						data.data.metadata.page.controls
							.find((c) => c.controlName == 'CoveragePackages')
							.options.find((o) => o.carrierName == carrierInformation.name)
					) {
						var coveragesPackagesControl = data.data.metadata.page.controls
							.find((c) => c.controlName == 'CoveragePackages')
							.options.find((o) => o.carrierName == carrierInformation.name);

						var packages = coveragesPackagesControl.packages;

						this.submissionLoaderPopup = coveragesPackagesControl.submissionLoaderPopup;

						var selectedPackage = filter(packages, (item) => {
							return item.active;
						})[0];

						this.selectedPackageType = selectedPackage.packageType
							? selectedPackage.packageType
							: this.selectedPackageType;

						this.selectedPackagePrice = selectedPackage.price ? selectedPackage.price : this.selectedPackagePrice;

						this.updateRateButton = packages.find((p) => p.packageType == this.selectedPackageType).updateRateButton;
						this.buyButton = packages.find((p) => p.packageType == this.selectedPackageType).buyButton;
					}
				}
			}
		});

		this.subscription = this.observablesService.pageUpdated.subscribe((action) => {
			if (this.model.metadata.page.state !== 'preloader') {
				setTimeout(() => {
					this.calcFixed();
				}, 0);
			}
		});

		this.layoutService.globalAttributes.subscribe((data) => {
			if (data) {
				if (data.applicationId) this.quoteNumber = data.applicationId.value;
			}
		});
	}

	calcFixed() {
		let isMobile =
			bowser.getParser(window.navigator.userAgent).getPlatformType() === 'mobile' ||
			bowser.getParser(window.navigator.userAgent).getPlatformType() === 'tablet';

		if (this.headerElem === undefined || this.contentElem === undefined || isMobile) {
			return;
		}

		const headerHeight = this.headerElem ? this.headerElem.getBoundingClientRect().height : undefined;
		const contentHeight = this.contentElem ? this.contentElem.getBoundingClientRect().top : undefined;

		if (contentHeight <= headerHeight) {
			this.addFixed();
		} else {
			this.removeFixed();
		}
	}

	removeFixed() {
		this.renderer.removeClass(this.elementRef.nativeElement, 'fixed');
		this.setTop(null);
	}

	addFixed() {
		const sidebarElm = document.getElementsByTagName('sidebar')[0].getBoundingClientRect().height;

		if (sidebarElm + this.headerElem.getBoundingClientRect().height - window.innerHeight >= 0) {
			this.renderer.removeClass(this.elementRef.nativeElement, 'fixed');
		} else {
			this.renderer.addClass(this.elementRef.nativeElement, 'fixed');
			this.setTop(this.headerElem.getBoundingClientRect().height);
		}
	}

	setTop(height) {
		this.elementRef.nativeElement.style.top = height ? `${height}px` : null;
	}

	finishAndBuyBtnClick() {
		if (this.isCovModFlagOn && this.isCustomizable) {
			this.showSubmissionLoaderPopup();
			// action should be RegisterSubmission
			if (this.buyButton.ajaxInfo.shouldUpdateBridgeURL) {
				this.actionService.ajaxAction(this.buyButton.ajaxInfo, this.context);
			}
			// action should be ShowBridgeNoteModal
			else {
				const carrierInformation = this.storeService.getValue('CarrierInformation', 'page');
				const requestBody: request = {
					data: {
						CarrierInformation: {
							name: carrierInformation.name,
							lobname: carrierInformation.lobname,
							packageType: this.selectedPackageType,
							quoteNumber: carrierInformation.quoteNumber,
						},
					},
					info: this.buyButton.ajaxInfo,
				};

				this.actionService.invokeAction(requestBody);

				if (!this.buyButton.disabled && !this.buyButton.ajaxInfo.shouldUpdateRedirectURL) {
					var win = window.open(
						this.setHref(this.buyButton),
						this.isAgentflowType ? this.buyButton.attributes.target : '_self'
					);
					win.focus();
				}
			}
		}
	}

	private showSubmissionLoaderPopup() {
		var carrierInformation = this.storeService.getValue('CarrierInformation', 'page');

		if (
			this.isSubmissionLoaderFlagOn &&
			this.submissionLoaderPopup &&
			((!this.isAgentflowType && carrierInformation.name != 'Homesite') ||
				(this.isAgentflowType && this.selectedPackageType != 'Custom'))
		) {
			this.submissionLoaderPopupData = {
				data: {
					title: this.submissionLoaderPopup.title,
					subtitle: this.submissionLoaderPopup.subtitle,
					secondSubtitle: this.submissionLoaderPopup.secondSubtitle,
					logo: this.submissionLoaderPopup.logo,
				},
			};
			this.showSubmissionLoader_Popup = true;

			const submissionLoaderElement = document.getElementById('submission-preloader-popup');
			if (submissionLoaderElement) {
				submissionLoaderElement.style.display = 'block'; // shows the loader
			}
		}
	}

	UpdateRateBtnClick() {
		if (this.isCovModFlagOn && this.isCustomizable && this.selectedPackageType == 'Custom') {
			var carrierInformation = this.storeService.getValue('CarrierInformation', 'page');

			const requestBody: request = {
				data: {
					carrierInformation: {
						carrierName: carrierInformation.name,
						lob: carrierInformation.lobname,
						packageType: this.selectedPackageType,
					},
				},
				info: {
					action: this.updateRateButton.ajaxInfo.action,
					conditions: '',
					elementSrc: '',
					stage: '',
					notRenderPage: true,
				},
			};

			this.carrierInformationService.setIsRecalculating(true);

			this.observablesService.showAjaxLoader.next(true);

			this.actionService.invokeAction(requestBody);
		}
	}

	setHref(buyButton) {
		this.linkExpiration.setLinkExpiration(buyButton.attributes.ReQuotedData);

		let carrierInformation = this.storeService.getValue('CarrierInformation', 'page');

		if (buyButton && buyButton.attributes && !isEmpty(buyButton.attributes.url)) {
			carrierInformation.buyButtonUrl = buyButton.attributes.url;
		}

		return !isEmpty(carrierInformation.buyButtonUrl)
			? carrierInformation.buyButtonUrl
			: !isEmpty(buyButton.attributes.url)
			? buyButton.attributes.url
			: '';
	}

	sanitize(url: string) {
		return this.sanitizer.bypassSecurityTrustUrl(url);
	}

	isEditMode() {
		return this.carrierInformationService.isEditMode;
	}

	phoneClick() {
		if (this.model.metadata.progressMeter.phoneNumber) {
			window.location.href = 'tel:' + this.model.metadata.progressMeter.phoneNumber;
		}
	}

	isRecalculating() {
		return this.carrierInformationService.isRecalculating;
	}
}
